import { DataField } from '@vendasta/protos/sms/v2/enums';

export const NORTH_AMERICA_COUNTRIES = ['US', 'CA'];

export const RegistrationStage = {
  NotSubmitted: 0,
  ReviewingInfo: 1,
  RegistrationComplete: 2,
  DataError: 3,
  CampaignError: 4,
} as const;
export type RegistrationStage = (typeof RegistrationStage)[keyof typeof RegistrationStage];

export const EIN_REGEX = /^\d{2}-\d{7}$/;
export const ZIP_CODE_REGEX = /^\d{5}(?:-\d{4})?$/;
export const URL_REGEX = /^https?:\/\/.+/i;
export const HTTPS_URL_REGEX = /^https:\/\/.+/i;
export const IDENTIFIER_TYPE_EIN = 'EIN';

export type SmsUsage = 'transactional' | 'marketing' | 'both';
export const SMS_USAGE_OPTIONS: readonly SmsUsage[] = ['transactional', 'marketing', 'both'];
export function isSmsUsage(value: unknown): value is SmsUsage {
  return SMS_USAGE_OPTIONS.includes(value as SmsUsage);
}

export const DEFAULT_SMS_USAGE: SmsUsage = 'both';
// Per Twilio Fast Track compliance feedback; server builds the verbal script.
export const DEFAULT_COLLECTS_VERBAL_CONSENT = true;
export const DEFAULT_VERBAL_CONSENT_SCRIPT = '';

export const DATA_FIELD_TO_FORM_FIELD = new Map<DataField, string>([
  ['DATA_FIELD_LEGAL_BUSINESS_NAME', 'businessName'],
  ['DATA_FIELD_BUSINESS_CATEGORY', 'businessCategory'],
  ['DATA_FIELD_BUSINESS_TYPE', 'businessType'],
  ['DATA_FIELD_REGION_OF_OPERATION', 'regionOfOperation'],
  ['DATA_FIELD_BUSINESS_REGISTRATION_NUMBER', 'businessRegistrationNumber'],
  ['DATA_FIELD_STREET_ADDRESS', 'address'],
  ['DATA_FIELD_STREET_ADDRESS_SECONDARY', 'additionalAddressLine'],
  ['DATA_FIELD_CITY', 'city'],
  ['DATA_FIELD_STATE', 'state'],
  ['DATA_FIELD_POSTAL_CODE', 'zipCode'],
  ['DATA_FIELD_WEBSITE_URL', 'website'],
  ['DATA_FIELD_COUNTRY', 'country'],
  ['DATA_FIELD_FIRST_NAME', 'firstName'],
  ['DATA_FIELD_LAST_NAME', 'lastName'],
  ['DATA_FIELD_JOB_POSITION', 'jobPosition'],
  ['DATA_FIELD_BUSINESS_TITLE', 'businessTitle'],
  ['DATA_FIELD_EMAIL', 'email'],
  ['DATA_FIELD_PHONE_NUMBER', 'phoneNumber'],
]);

// Campaign fields Vendasta generates on the SMB's behalf (samples, description,
// auto-replies). The SMB can't edit these in the form, so a rejection that only
// cites them isn't theirs to fix.
export const VENDASTA_OWNED_CAMPAIGN_FIELDS = new Set([
  'description',
  'message_samples',
  'opt_in_message',
  'opt_in_keywords',
  'opt_out_message',
  'opt_out_keywords',
  'help_message',
  'help_keywords',
  'has_embedded_links',
  'has_embedded_phone',
]);

// Deep link targets for the A2P form stepper. Notification templates link with
// ?step=<token>, so these tokens are a public contract — don't renumber, and add
// rather than repurpose.
export const A2P_FORM_STEP_QUERY_PARAM = 'step';
export const A2P_FORM_STEP_INDEX: Record<string, number> = {
  brand: 0,
  campaign: 1,
  review: 2,
};
